function formatGoalValueToHhMm(value) {
  if (!value || typeof value !== 'string') return value
  // Converts decimal hours (e.g. "0.0 / 8.0 hrs" or "1.5 / 8.0 hrs") to hh:mm format ("00:00 / 08:00 hrs")
  return value.replace(/(\d+(?:\.\d+)?)\s*\/\s*(\d+(?:\.\d+)?)\s*hrs?/i, (match, act, ideal) => {
    if (act.includes(':') && ideal.includes(':')) return match
    const actMins = Math.round(parseFloat(act) * 60)
    const actH = Math.floor(actMins / 60)
    const actM = actMins % 60
    const idealMins = Math.round(parseFloat(ideal) * 60)
    const idealH = Math.floor(idealMins / 60)
    const idealM = idealMins % 60
    const fmtAct = `${String(actH).padStart(2, '0')}:${String(actM).padStart(2, '0')}`
    const fmtIdeal = `${String(idealH).padStart(2, '0')}:${String(idealM).padStart(2, '0')}`
    return `${fmtAct} / ${fmtIdeal} hrs`
  })
}

export default function ProductivityCard({ score, goalLabel, goalValue, progress }) {
  const formattedGoalValue = formatGoalValueToHhMm(goalValue)

  return (
    <article className="overflow-hidden rounded-lg bg-surface-container-lowest p-6">
      <div className="mb-6 flex items-start justify-between">
        <div>
          <h3 className="mb-1 text-[11px] font-semibold uppercase tracking-wider text-on-surface-variant">
            Productivity Score
          </h3>
          <p className="text-5xl font-black text-primary">{score}%</p>
        </div>
        <div className="rounded-xl bg-primary/10 p-3 text-primary">
          <span className="material-symbols-outlined text-3xl">bolt</span>
        </div>
      </div>

      <div>
        <div className="mb-2 flex items-center justify-between text-[11px] font-bold text-on-surface-variant">
          <span>{goalLabel}</span>
          <span>{formattedGoalValue}</span>
        </div>
        <div className="h-2 w-full overflow-hidden rounded-full bg-surface-variant">
          <span className="block h-full rounded-full bg-primary" style={{ width: `${progress}%` }} />
        </div>
      </div>
    </article>
  )
}
